module.exports = __webpack_public_path__ + "static/media/skip-backward-w64.a1fd9395.svg";